<template>
    <div v-if="engagements.length > 1">
        <div v-for="(engagement, index) in engagements">
            <club-participant :engagement="engagement"></club-participant>
        </div>
        <div v-if="loading" class="text-center loading-spinner">
            <i aria-hidden="true" class="fa fa-3x fa-circle-o-notch fa-spin"> </i>
        </div>
        <div v-if="more" class="text-center more-button">
            <button @click="loadMore()" :disabled="loading" class="btn btn-primary btn-sm">Load more</button>
        </div>
    </div>
    <div class ="text-center" v-else>
        <h3 v-if="owned"><i class="fa fa-fw fa-flag"></i> You have no activity</h3>
        <h3 v-else><i class="fa fa-fw fa-flag"></i> {{ user.first_name }} has no activity</h3>
        <a :href="findEventUrl" class="btn btn-primary">Find Events</a>
        <a :href="findClubsUrl" class="btn btn-primary">Find Clubs</a>
    </div>
</template>


<script>

import ClubParticipant from './Entities/ClubParticipant.vue';

export default {
    name: "ClubList",
    props: {
        user: {
            type: Object,
            default: () => ({})
        },
        club: {
            type: Object,
            default: () => ({})
        },
        owned:{
            type: Boolean,
            default: false
        },
        findEventUrl:{
            type: String,
            default:'',
            required: false
        },
        findClubsUrl:{
            type: String,
            default:'',
            required: false
        }
    },
    components: {
        ClubParticipant
    },
    data() {
        return {
            engagements: [],
            page: 1,
            loading: true,
            more: false,
        }
    },
    created() {
        // get the first page of engagements
        this.getEngagements();
    },
    methods: {
        getEngagements() {

            this.loading = true;

            var url = '/api/v0/engagements/club/' + this.club.id + '?page=' + this.page + '&limit=10';

            axios.get(url, {
                headers: {
                    'Accept': 'application/json'
                }
            }).then(response => {

                response.data.data.forEach((engagement, index) => {
                    this.engagements.push(engagement);
                });

                if (response.data.pagination.page !== response.data.pagination.pages && response.data.pagination.count !== 0) {
                    this.more = true;
                } else {
                    this.more = false;
                }

                this.initialLoad = false;
                this.loading = false;
            }).catch(error => {
                alert('We encountered a problem.  Please report this to support@eventrac.co.uk');
            })
        },
        loadMore: function () {
            this.page = this.page + 1;
            this.getEngagements();
        }
    }
}
</script>

<style scoped>
.more-button {
    padding-top: 10px;
}

.loading-spinner {
    padding-top: 10px;
    padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// plugins/Crm/UsersFeed/Assets/components/Engagements/ClubList.vue